import React, { useEffect, useRef } from "react";
import IndustryCard from "../../common/IndustryCard/IndustryCard";
import styles from "./Industries.module.scss";

const Industries = () => {
  const industries = [
    "Retail/Reselling Stores",
    "Subscription Services",
    "Rent Collection",
    "Professionals & Consultants",
    "Loan Management",
  ];

  // Duplicate the industries to create an infinite loop effect
  const repeatedIndustries = [...industries, ...industries, ...industries, ...industries, ...industries, ...industries, ...industries, ...industries, ...industries, ...industries];

  const scrollRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    
    if (!scrollContainer) return;

    let scrollAmount = 0;
    const speed = 0.5; // Adjust speed of scrolling

    const scroll = () => {
      if (scrollAmount >= scrollContainer.scrollWidth / 2) {
        scrollAmount = 0; // Reset to create loop effect
        scrollContainer.scrollLeft = 0;
      } else {
        scrollAmount += speed;
        scrollContainer.scrollLeft = scrollAmount;
      }
      requestAnimationFrame(scroll);
    };

    const animation = requestAnimationFrame(scroll);
    
    return () => cancelAnimationFrame(animation);
  }, []);

  return (
    <section className={styles.industries}>
      <div className={styles.content}>
        <h2>Industries we Serve</h2>
        <p>
          From small businesses to large enterprises, EMIfy simplifies collections across all industries.
        </p>
      </div>
      <div className={styles.carouselContainer} ref={scrollRef}>
        <div className={styles.cards}>
          {repeatedIndustries.map((industry, idx) => (
            <IndustryCard key={idx} title={industry} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
